import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset } from 'app/model/dataset/azure-data-lake-store-gen2-cosmos-structured-stream.dataset';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { DatasetAdapter } from 'app/model/adapters/datasets/dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            schema: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                folderPath: '*',
                fileName: '*',
                fileSystem: '*',
                generatedFromActivity: '*'
            }
        }
    }
})

export class AzureDataLakeStoreGen2CosmosStructuredStreamFileDatasetAdapter extends DatasetAdapter<AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.AzureDataLakeStoreGen2CosmosStructuredStreamDataset;
        modelDataset.type = Metamodel.modelFor(AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset).name;
        if (dataset.isV2) {
            modelDataset.schema = this.columnValueToResource(dataset, dataset.columns);
        } else {
            modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        }
        modelDataset.typeProperties = {
            fileName: ValueAdapter.toResource(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FILE_NAME),
            folderPath: ValueAdapter.toResource(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FOLDER_PATH),
            fileSystem: ValueAdapter.toResource(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FILE_SYSTEM),
            generatedFromActivity: dataset.generatedFromActivity
        };
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset
    ): Promise<AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset> {
            if (!dataset) {
                dataset =
                AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.MODEL.create<AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset>(
                    modelDatasetResource.name);
            }
            await super._toModel(modelDatasetResource, dataset);
            const model = modelDatasetResource.properties as Model.AzureDataLakeStoreGen2CosmosStructuredStreamDataset;
            if (model) {
                if (model.typeProperties != null) {
                    ValueAdapter.toModel(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FILE_NAME, model.typeProperties.fileName);
                    ValueAdapter.toModel(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FOLDER_PATH, model.typeProperties.folderPath);
                    ValueAdapter.toModel(dataset, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.FILE_SYSTEM, model.typeProperties.fileSystem);
                    dataset.generatedFromActivity = model.typeProperties.generatedFromActivity;
                }
                dataset.columns = this.columnResourceToValue(dataset, model.structure);
                dataset.isV2 = model.schema != null;
                const cols = dataset.isV2 ? model.schema : model.structure;
                if (!dataset.isV2) { // v1
                    dataset.columns = this.columnResourceToValue(dataset, cols);
                } else if (Array.isArray(cols)) { // v2
                    dataset.columns = this.columnResourceToValue(dataset, cols);
                    dataset.columns.forEach((c) => {
                        c.physicalType = c.columnType;
                    });
                }
            }
            dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset.MODEL));
            return dataset;
    }
}
